<template>
  <div class="page">
    <div class="header">
      <div class="description">
        <h1 class="title">Relatórios</h1>
      </div>

      <header-actions>
        <button-dropdown color="primary">
          <template slot="button-content">Período: {{ period }} dias</template>

          <button-dropdown-item type="button" @click="period = 30">30 dias</button-dropdown-item>
          <button-dropdown-item type="button" @click="period = 60">60 dias</button-dropdown-item>
          <button-dropdown-item type="button" @click="period = 90">90 dias</button-dropdown-item>
        </button-dropdown>
      </header-actions>
    </div>

    <div class="flex flex-col gap-4">
      <div class="w-full">
        <queries-overview :period="period"/>
      </div>

      <div class="w-full flex gap-4">
        <div class="w-1/3 flex-initial flex items-stretch">
          <utilization-by-week-day-radar-chart :period="period"/>
        </div>
        <div class="w-2/3 flex-initial flex items-stretch">
          <credits-utilization :period="period"/>
        </div>
      </div>

      <div class="w-full flex gap-4">
        <div class="w-1/2 flex-initial flex items-stretch">
          <types-most-used-pie-chart :period="period"/>
        </div>

        <div class="w-1/2 flex-initial flex items-stretch">
          <consultations-most-used-pie-chart :period="period"/>
        </div>
      </div>

      <div class="w-full">
        <query-log :period="period"/>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderActions from '@/support/components/page/HeaderActions.vue';
import ButtonDropdown from '@/support/components/buttons/ButtonDropdown.vue';
import ButtonDropdownItem from '@/support/components/buttons/button-dropdown/ButtonDropdownItem.vue';
import QueriesOverview from '@/metrics/components/period/QueriesOverview.vue';
import UtilizationByWeekDayRadarChart from '@/metrics/components/period/UtilizationByWeekDayRadarChart.vue';
import CreditsUtilization from '@/metrics/components/period/CreditsUtilization.vue';
import TypesMostUsedPieChart from '@/metrics/components/period/TypesMostUsedPieChart.vue';
import ConsultationsMostUsedPieChart from '@/metrics/components/period/ConsultationsMostUsedPieChart.vue';
import QueryLog from '@/metrics/components/period/QueryLog.vue';

export default {
  name: 'Index',

  data() {
    return {
      period: 30,
    };
  },

  components: {
    HeaderActions,
    ButtonDropdown,
    ButtonDropdownItem,
    QueriesOverview,
    UtilizationByWeekDayRadarChart,
    CreditsUtilization,
    TypesMostUsedPieChart,
    ConsultationsMostUsedPieChart,
    QueryLog,
  },
};
</script>

<style lang="scss" scoped>

</style>
